import { Platform } from 'react-native';

import { HeadingTextProps, Text } from '../text';

export type HeaderTitleTextProps = Partial<Omit<HeadingTextProps, 'children'>> & {
  text: string;
};

export function HeaderTitleText({ text, ...props }: HeaderTitleTextProps) {
  // Web: headings are not in the tab order by default; tabIndex 0 lets keyboard
  // users focus the page title (e.g. after “skip to content”).
  const webTabIndex = Platform.OS === 'web' ? (0 as const) : undefined;

  return (
    <Text.Heading
      type="four"
      accessibilityLevel={1}
      accessible
      accessibilityLabel={text}
      tabIndex={webTabIndex}
      {...props}
    >
      {text}
    </Text.Heading>
  );
}
